import { render, staticRenderFns } from "./CustomerPurchaseOrderSelect.vue?vue&type=template&id=230aa186"
import script from "./CustomerPurchaseOrderSelect.vue?vue&type=script&lang=js"
export * from "./CustomerPurchaseOrderSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports